import React from 'react';
import '../MarketDetails/style.less';
import { apiBatchRequest } from '../../../utils/api_service';
import { API_URL } from '../../../constants/api';
import { ShowToast, toastType } from '../../../utils/toast-service';
import { marketDetailsFormConfig, MarketPropertyDetailsColumns } from '../../../constants/MockData';
import { UpdateFieldsWithConfiguration, UpdateColumnWithConfiguration } from '../../../utils/helper';
import GridTable from '../../common/Table/Table';
import commonLabels from '../../../constants/messageConstants';
import FormGenerator from '../../common/FormGenerator';
class MarketDetails extends React.PureComponent {
  constructor (props) {
    super(props);
    this.state = {
      MarketDetails: undefined,
      PropertyData: undefined,
      configuration: undefined
    };
  }

  componentDidMount () {
    //  const query = useQuery();

    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Market.GetMarketDetails,
        key: 'MarketDetailsData',
        params: { marketId: this.props.selectedMarketID }
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'MarketMasterData'
      },
      {
        url: API_URL.Employee.GetDepartmentMasterData,
        key: 'DepartmentMasterData'
      },
      {
        url: API_URL.Property.GetPropertyData,
        key: 'PropertyData',
        params: { marketId: this.props.selectedMarketID }
      }
    ])
      .then(({ MarketDetailsData, MarketMasterData, DepartmentMasterData, PropertyData }) => {
        if (MarketDetailsData.success === true) {
          this.setState({
            MarketDetails: MarketDetailsData.data || [],
            PropertyData: PropertyData.data || [],
            configuration: PropertyData.config || [],
            DepartmentMasterData: DepartmentMasterData.data || [],
            MarketMasterData: MarketMasterData.data || []
          });
        } else {
          ShowToast(commonLabels.somethingWrong, toastType.ERROR, 5000, 500, 'Server error');
        }
      })
      .catch(() => {
        this._asyncRequest = null;
        ShowToast(commonLabels.somethingWrong, toastType.ERROR, 5000, 500, 'Server error');
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  render () {
    const { MarketDetails, PropertyData, MarketMasterData, DepartmentMasterData, configuration } = this.state;

    const dropDownSource = [{
      key: 'marketName',
      option: 'marketName',
      idField: 'marketId',
      source: MarketMasterData
    }, {
      key: 'typeName',
      option: 'departmentName',
      idField: 'departmentId',
      source: DepartmentMasterData
    }];
    return (
      <>
        {MarketDetails && (
          <>
            <FormGenerator gridColumn={2}
              formFields={UpdateFieldsWithConfiguration(MarketDetails, marketDetailsFormConfig)}
              dropDownSource={dropDownSource}
            ></FormGenerator>
            {' '}
            {/* <div className="row Row_Flex bottom-lg " style={{ padding: '20px' }}>
              <div className="col-xs-12 col-sm-4 col-lg-6  ">
                {' '}
                <TextField id="Market-id" label={MarketDetails[0].displayName} fullWidth value={MarketDetails[0].attributeValue} />
              </div>
              <div className="col-xs-12  col-sm-4 col-lg-6 ">
                {' '}
                <TextField id="Name" label={MarketDetails[1].displayName} fullWidth value={MarketDetails[1].attributeValue} />
              </div>
            </div>
            <div className="row Row_Flex bottom-lg" style={{ padding: '20px' }}>
              <div className="col-xs-12  col-sm-4 col-lg-6 ">
                {' '}
                <TextField id="status" label={MarketDetails[4].displayName} fullWidth value={MarketDetails[4].attributeValue} />
              </div>
              <div className="col-xs-12  col-sm-4 col-lg-6 ">
                <label className="label-textarea">Address</label>
                <TextareaAutosize
                  aria-label={MarketDetails[2].displayName}
                  label={MarketDetails[2].displayName}
                  rowsMin={3}
                  style={{ width: '100%' }}
                  value={MarketDetails[2].attributeValue}
                  placeholder="Enter Address"
                />
              </div>
            </div>
         */} </>
        )}

        <div className="row table-list-container">
          <GridTable
            columns={UpdateColumnWithConfiguration(MarketPropertyDetailsColumns, configuration)}
            data={PropertyData}
            config={configuration}
            renderActionColumn={this.renderActionColumn}
          ></GridTable>
        </div>
      </>
    );
  }
}

export default MarketDetails;
